<template>
  <nav class="breadcrumb">
    <ul>
      <li v-for="(item, index) in breadcrumbs" :key="index">
        <router-link 
          v-if="item.link" 
          :to="item.link" 
          class="main link-item" 
          @click.native="handleClick(item)"
        >
          {{ item.text }}
        </router-link>
        <span v-else class="main text-item">{{ item.text }}</span>
        <span v-if="index < breadcrumbs.length - 1" class="separator"> > </span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleClick(item) {
      if (item && (item.text === "Inventory" || item.text === "Items")) {
        if (this.$eventBus) {
          this.$eventBus.$emit("title", { value: 14 });
        }
      }
    }
  }
};
</script>

<style scoped>
.breadcrumb {
  display: flex;
  padding-bottom: 0px;
  font-weight: 500;
  color: #444;
  font-family: TTNormsMedium, sans-serif;
}

.breadcrumb ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 0px;
}

.breadcrumb li {
  display: flex;
  align-items: center;
  gap: 8px;
}

.breadcrumb .main {
  color: #005eb8;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb .link-item {
  color: #005eb8;
  cursor: pointer;
}

.breadcrumb .link-item:hover {
  color: #00468b;
  text-decoration: underline;
}

.breadcrumb .text-item {
  color: #64748b;
  font-weight: 600;
}

.breadcrumb .separator {
  color: #94a3b8;
  font-weight: 600;
}
</style>
